export function getConfig() {
  
    return {
      API_URL:  process.env.REACT_APP_API_URL,
      AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
      AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
      AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
      BRANCH: process.env.REACT_APP_BRANCH,
    };
}